// extracted by mini-css-extract-plugin
module.exports = {"last-visited-wrapper":"LastVisited_last-visited-wrapper__29Zjw"};